import { t } from '@lingui/core/macro';
import { Plural, Trans } from '@lingui/react/macro';
import { useState } from 'react';

import FilterIcon from '@/assets/svg/filter.svg?react';
import { Toggle } from '@/components/buttons';
import {
  type QueryStateFilter,
  type QueryStateFilterMulti,
  useInstantSearchState,
} from '@/components/InstantSearch';
import { Tooltip, TooltipContent, TooltipTitle, TooltipTrigger } from '@/components/Tooltip';

import RuleFilterDialog from './RuleFilterDialog';

const RuleFilter = () => {
  const { queryState, updateQueryState } = useInstantSearchState();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState<boolean>(false);
  const channelFilter = queryState.filters.find((filter) => filter.field === 'channel.id') as
    | QueryStateFilterMulti
    | undefined;
  const vendorFilter = queryState.filters.find((filter) => filter.field === 'vendor.id') as
    | QueryStateFilterMulti
    | undefined;

  const handleFiltersChange = (channels: string[], vendors: string[]) => {
    const filters: QueryStateFilter[] = [];

    if (channels.length) {
      filters.push({
        field: 'channel.id',
        operator: 'in',
        operand: channels,
      });
    }
    if (vendors.length) {
      filters.push({
        field: 'vendor.id',
        operator: 'in',
        operand: vendors,
      });
    }

    updateQueryState({ filters });
    setIsFilterModalOpen(false);
  };

  return (
    <>
      <Tooltip>
        <TooltipTrigger
          render={
            <Toggle
              aria-label={t`Add or remove filters`}
              variant="secondary"
              shape="square"
              size="icon"
              pressed={queryState.filters.length > 0}
              onClick={() => setIsFilterModalOpen(true)}
            >
              <FilterIcon />
            </Toggle>
          }
        />
        <TooltipContent side="top" align="end" className="flex-col items-start">
          <TooltipTitle>
            <Trans>Add/Remove Filters</Trans>
          </TooltipTitle>
          <span>
            <Trans>
              Add or Remove filters. {queryState.filters.length}{' '}
              <Plural value={queryState.filters.length} one="filter" other="filters" /> applied.
            </Trans>
          </span>
        </TooltipContent>
      </Tooltip>
      <RuleFilterDialog
        open={isFilterModalOpen}
        channels={channelFilter?.operand || []}
        vendors={vendorFilter?.operand || []}
        onClose={() => setIsFilterModalOpen(false)}
        onFiltersChange={handleFiltersChange}
      />
    </>
  );
};

export default RuleFilter;
